(ns superadmin.roles.data
  (:require [common.graph :as g]))

(def permission-resources
  "Resources and their available actions for role permissions.
   Matches project-docs/permissions-spec.md exactly."
  [{:id "agency" :label "Agency"
    :actions [{:id "list" :label "List"}
              {:id "view" :label "View"}
              {:id "create" :label "Create"}
              {:id "edit" :label "Edit"}
              {:id "delete" :label "Delete"}]}
   {:id "useraccounts" :label "User Accounts"
    :actions [{:id "list" :label "List"}
              {:id "view" :label "View"}
              {:id "create" :label "Create"}
              {:id "edit" :label "Edit"}
              {:id "delete" :label "Delete"}]}
   {:id "roles" :label "Roles"
    :actions [{:id "view" :label "View"}
              {:id "create" :label "Create"}
              {:id "edit" :label "Edit"}
              {:id "delete" :label "Delete"}]}
   {:id "advertisers" :label "Advertisers"
    :actions [{:id "list" :label "List"}
              {:id "view" :label "View"}
              {:id "create" :label "Create"}
              {:id "edit" :label "Edit"}
              {:id "delete" :label "Delete"}]}
   {:id "campaigns" :label "Campaigns"
    :actions [{:id "list" :label "List"}
              {:id "view" :label "View"}
              {:id "create" :label "Create"}
              {:id "edit" :label "Edit"}
              {:id "delete" :label "Delete"}]}
   {:id "adsets2" :label "Adsets"
    :actions [{:id "list" :label "List"}
              {:id "view" :label "View"}
              {:id "create" :label "Create"}
              {:id "edit" :label "Edit"}
              {:id "delete" :label "Delete"}]}
   {:id "adsets2" :label "Adsets +"
    :actions [{:id "ads-edit" :label "Ads Edit"}
              {:id "ads-qa" :label "Ads QA"}
              {:id "dt-edit" :label "DT Edit"}
              {:id "dt-toggle-ads" :label "DT Toggle Ads"}]}
   {:id "products" :label "Products"
    :actions [{:id "view" :label "View"}
              {:id "create" :label "Create"}
              {:id "edit" :label "Edit"}
              {:id "delete" :label "Delete"}
              {:id "configure" :label "Configure"}]}
   {:id "dynamicFeeds" :label "Dynamic Feeds"
    :actions [{:id "view" :label "View"}
              {:id "create" :label "Create"}
              {:id "edit" :label "Edit"}
              {:id "delete" :label "Delete"}]}
   {:id "templates" :label "Templates"
    :actions [{:id "view" :label "View"}
              {:id "create" :label "Create"}
              {:id "edit" :label "Edit"}
              {:id "delete" :label "Delete"}]}
   {:id "mediaAssets" :label "Media Assets"
    :actions [{:id "view" :label "View"}
              {:id "create" :label "Create"}
              {:id "edit" :label "Edit"}
              {:id "delete" :label "Delete"}]}
   {:id "adservers" :label "Adservers"
    :actions [{:id "view" :label "View"}
              {:id "create" :label "Create"}
              {:id "edit" :label "Edit"}
              {:id "delete" :label "Delete"}]}])

(def v2-permission-dependencies
  "Graph describing dependencies between permissions for RBAC v2.
   Limited to dependencies that exist in the legacy system for now.
   Keys are `[:resource :action]` that depend on values (also `[:resource :action]` sequences).
   When enabling a permission, all dependencies are automatically enabled.
   When disabling a dependency, all dependants are automatically disabled."
  {;; Dependencies that exist in the legacy system
   [:campaigns :create] [[:campaigns :edit]]  ; from :create+delete
   [:campaigns :delete] [[:campaigns :edit]]  ; from :create+delete
   [:campaigns :edit] [[:campaigns :view]]

   [:products :configure] [[:products :edit]]
   [:products :edit] [[:products :view]]

   [:adsets2 :edit] [[:adsets2 :view]]
   [:adsets2 :create] [[:adsets2 :edit]]  ; from :create+delete
   [:adsets2 :delete] [[:adsets2 :edit]]  ; from :create+delete

   [:templates :create] [[:templates :edit]]  ; from :create+delete
   [:templates :delete] [[:templates :edit]]  ; from :create+delete
   [:templates :edit] [[:templates :view]]

   ;; Cross-resource dependencies (same as legacy)
   [:adsets2 :view] [[:campaigns :view]
                     [:templates :view]
                     [:products :view]]})

(defn apply-permission-dependencies
  "Apply permission dependencies when toggling a permission.
   Returns updated permissions map with all dependent permissions set."
  [permissions resource-id action-id checked]
  (let [target-key [(keyword resource-id) (keyword action-id)]
        graph (cond-> v2-permission-dependencies (not checked) g/invert)]
    (reduce (fn [acc [res-kw act-kw]]
              (if checked
                (assoc-in acc [res-kw act-kw] "allowed")
                ;; When disabling, remove the permission entirely
                (let [resource-perms (get acc res-kw {})
                      updated-resource (dissoc resource-perms act-kw)]
                  (if (empty? updated-resource)
                    (dissoc acc res-kw)
                    (assoc acc res-kw updated-resource)))))
            permissions
            (g/depth-first-search graph target-key))))